import { getVersionForClone } from '../../utils/clone'
import baseSwitch from './BaseSwitch'
import clone1Switch from './Clone1Switch'

export * from './BaseSwitch'

export const Switch = getVersionForClone({
	base: baseSwitch,
	clone1: clone1Switch,
})
